<template>
  <div class="filter-container">
    <el-form :model="query" ref="queryForm" :inline="true" size="small">   
      <el-form-item label="跟进者类型：" prop="followUpByType">
        <el-select v-model="query.followUpByType" placeholder="请选择跟进者类型" clearable>
          <el-option label="业务" :value="1"></el-option>
          <el-option label="技术老师" :value="2"></el-option>
          <el-option label="服务老师" :value="3"></el-option>
        </el-select>
      </el-form-item>
    
      
      <el-form-item label="跟进时间：" prop="createdTime">
        <el-date-picker v-model="query.createdTime" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      </el-form-item>
      
      <el-form-item>
        <el-button type="primary" @click="handleQuery">导出</el-button>
        <el-button @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import clientListApi from '@/api/client/clientList'
export default {
  data() {
    return {
      query: {
        followUpByType: '', // 跟进者类型（1|业务 2|技术老师 3|服务老师）
        createdTime: [] // 创建时间范围
      }
    }
  },
  methods: {

    // 查询
    handleQuery() {
      // 构建导出参数
      let params = {}
      
      // 添加时间参数
      if (this.query.createdTime && this.query.createdTime.length === 2) {
        params.createdTimeEnd = this.query.createdTime[1]
        params.createdTimeStart = this.query.createdTime[0]
      }
      
      // 添加跟进者类型参数
      if (this.query.followUpByType) {
        params.followUpByType = this.query.followUpByType
      }
      
      console.log('导出参数:', params)
      
      return this.$common.confirm('是否确认导出')
        .then(() => clientListApi.exportForFollowUp(params)).then((res) => {
          if (res.code === '0') {
            this.$message.success('导出成功')
            this.$emit('created')
          }
        }).catch(err => {
          this.$message.error('导出失败')
          console.error('导出客户跟进记录失败:', err)
        })
    },
    // 重置
    resetQuery() {
      this.query = {
        followUpByType: '',
        createdTime: []
      }
    }
  }
}
</script>

<style scoped>
.filter-container {
  margin-bottom: 20px;
}
</style>
